import React from "react";
import { Form, Button, ButtonGroup, Dropdown } from "react-bootstrap";

//  * @property {string[]} stores
//  * @property {number} months
//  * @property {(m: number) => void} setMonths

/**
 * @typedef {Object} SalesFilterBarProps
 * @property {import("../../../components/dashboard/Sidebar").ReportKey} report
 * @property {string} today
 * @property {string} oneYearAgo
 * @property {string} startDate
 * @property {(s: string) => void} setStartDate
 * @property {string} endDate
 * @property {(s: string) => void} setEndDate
 * @property {string} store
 * @property {(s: string) => void} setStore
 * @property {import("../../../models/StoreModel").StoreModel[]} stores
 * @property {string} category
 * @property {(s: string) => void} setCategory
 * @property {import("../../../models/CategoryModel").CategoryModel[]} categories
 * @property {string} salesagent
 * @property {(s: string) => void} setSalesAgent
 * @property {import("../../../models/SalesAgentsModel").SalesAgentModel[]} salesAgents
 * @property {() => void} onRefresh
 */

/**
 * @param {SalesFilterBarProps} props
 */
export function SalesFilterBar({
  // months,
  // setMonths,
  report,
  today,
  oneYearAgo,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  store,
  setStore,
  stores,

  category,
  setCategory,
  categories,

  salesagent,
  setSalesAgent,
  salesAgents,

  onRefresh,
}) {
  // /** @type {{ label: string; value: number }[]} */
  // const ranges = [
  //   { label: "3M", value: 3 },
  //   { label: "6M", value: 6 },
  //   { label: "12M", value: 12 },
  // ];

  // /** @type {{ k: SalesCompareMode; label: string }[]} */
  // const compareOptions = [
  //   { k: "mom", label: "MoM" },
  //   // { k: "yoy", label: "YoY" },
  //   // { k: "cumulative", label: "Cumulative" },
  // ];

  return (
    <div className="pbi-filterbar">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <i className="bi bi-graph-up-arrow text-info" />
        <span className="fw-semibold me-2">Sales Filters</span>

        {/* <ButtonGroup size="sm">
          {ranges.map((r) => (
            <Button
              key={r.value}
              variant={months === r.value ? "info" : "outline-secondary"}
              className={months === r.value ? "text-white" : ""}
              onClick={() => setMonths(r.value)}
            >
              {r.label}
            </Button>
          ))}
        </ButtonGroup> */}
        <div className="d-flex align-items-center gap-2">
          <Form.Control
            type="date"
            size="sm"
            style={{ width: 150 }}
            value={startDate}
            min={oneYearAgo}
            max={endDate || today}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <span className="text-muted small">to</span>
          <Form.Control
            type="date"
            size="sm"
            style={{ width: 150 }}
            value={endDate}
            min={startDate || oneYearAgo}
            max={today}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        {/* <ButtonGroup size="sm">
          {compareOptions.map((c) => (
            <Button
              key={c.k}
              variant={compare === c.k ? "primary" : "outline-secondary"}
              onClick={() => setCompare(c.k)}
            >
              {c.label}
            </Button>
          ))}
        </ButtonGroup> */}
        {report !== "sales-record" && report !== "sales-by-agent" && (
          <Dropdown>
            <Dropdown.Toggle size="sm" variant="outline-secondary">
              <i className="bi bi-shop me-1" />
              {store === "all"
                ? "All stores"
                : stores.find((s, i) => s.storecode === Number(store))
                    ?.storename}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setStore("all")}>
                All stores
              </Dropdown.Item>
              <Dropdown.Divider />
              {stores.map((s) => (
                <Dropdown.Item
                  key={s.storecode}
                  onClick={() => setStore(s.storecode.toString())}
                >
                  {s.storename}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}

        <Dropdown>
          <Dropdown.Toggle size="sm" variant="outline-secondary">
            <i className="bi bi-person me-1" />
            {salesagent === "all"
              ? "All Agents"
              : salesAgents.find((s, i) => s.employeescode === salesagent)
                  .employeesname}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setSalesAgent("all")}>
              All Agents
            </Dropdown.Item>
            <Dropdown.Divider />
            {salesAgents.map((s) => (
              <Dropdown.Item
                key={s.employeescode}
                onClick={() => setSalesAgent(s.employeescode)}
              >
                {s.employeesname}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        {/* <Dropdown>
          <Dropdown.Toggle size="sm" variant="outline-secondary">
            <i className="bi bi-shop me-1" />
            {category === "all" ? "All Categories" : category}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setCategory("all")}>
              All Categories
            </Dropdown.Item>
            <Dropdown.Divider />
            {categories.map((s) => (
              <Dropdown.Item
                key={s.id}
                *how will we filter invoices based on category??
                onClick={() => setCategory(s.id)}
              >
                {s.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown> */}

        {/* <Form.Select size="sm" style={{ width: 150 }} defaultValue="all">
          <option value="all">All channels</option>
          <option>POS</option>
          <option>Online</option>
          <option>Phone</option>
        </Form.Select> */}
      </div>

      <div className="d-flex align-items-center gap-2">
        <Button size="sm" variant="outline-secondary" onClick={onRefresh}>
          <i className="bi bi-arrow-clockwise" />
        </Button>
        <Button size="sm" variant="outline-secondary">
          <i className="bi bi-download me-1" />
          Export
        </Button>
      </div>
    </div>
  );
}
